import usePcrV2 from 'components/v2/compiler/hooks/usePcrV2';

enum PCRVersion {
  V1 = 'v1',
  V2 = 'v2',
}

const fieldHints = {
  'EPDCompiler.ProductInformation.ContentDeclaration.DeclareContent': {
    [PCRVersion.V1]:
      'The gross weight of material in the content declaration shall cover 100% of one unit of product and its packaging. If there is more than 5% (post-consumer) recycled or biogenic content in the product, this shall be declared (if below 5%, this may be declared). If the share of biobased/recycled material is unknown, this part of the content declaration can be left out or be declared as 0% (a conservative estimate) or unknown.',
    [PCRVersion.V2]:
      'The gross mass of material in the content declaration shall cover 100% of one unit of product and its packaging. If there is more than 5% biogenic and/or post-consumer recycled content in the product, this shall be declared (if below 5%, this may be declared). If the share of biogenic/recycled material is unknown, this part of the content declaration can be left out or be declared as 0% (a conservative estimate) or unknown.',
  },
  'EPDCompiler.PcrInformation.PcrReviewWasConductedBy': {
    [PCRVersion.V1]:
      'Review chair: Claudia A. Peña, University of Concepción, Chile. The review panel may be contacted via the Secretariat www.environdec.com/support.',
    [PCRVersion.V2]:
      'Review chair: Rob Rouwette (chair), Noa Meron (co-chair). The review panel may be contacted via the Secretariat www.environdec.com/support.',
  },
};

export const FieldHintText: React.FC<{ fieldName: keyof typeof fieldHints }> = ({ fieldName }) => {
  const isModelV2 = usePcrV2();
  const field = fieldHints[fieldName];
  const version = isModelV2 ? PCRVersion.V2 : PCRVersion.V1;

  return field?.[version] || null;
};
